export const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
})

export function convertToMoney(numb) {
  //if (!numb) return
  return formatter.format(numb / 100).replace(/[.,]00$/, "")
}